import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AlertBanner = ({ severity, message, timestamp, onDismiss, actionLabel, onAction }) => {
  const getSeverityStyles = () => {
    switch (severity) {
      case 'critical':
        return 'bg-error/10 border-error text-error-foreground';
      case 'warning':
        return 'bg-warning/10 border-warning text-warning-foreground';
      case 'info':
        return 'bg-info/10 border-info text-info-foreground';
      default:
        return 'bg-muted border-border text-muted-foreground';
    }
  };

  const getIcon = () => {
    switch (severity) {
      case 'critical':
        return 'AlertTriangle';
      case 'warning':
        return 'AlertCircle';
      case 'info':
        return 'Info';
      default:
        return 'Bell';
    }
  };

  return (
    <div className={`border-l-4 rounded-lg p-4 mb-4 ${getSeverityStyles()} animation-organic`}>
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0 mt-1">
          <Icon name={getIcon()} size={20} color="currentColor" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-medium mb-1">{message}</p>
          <p className="text-sm opacity-80">{timestamp}</p>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          {actionLabel && onAction && (
            <Button variant="outline" size="sm" onClick={onAction}>
              {actionLabel}
            </Button>
          )}
          {onDismiss && (
            <button 
              onClick={onDismiss}
              className="p-1 hover:bg-background/20 rounded transition-colors"
              aria-label="Dismiss alert"
            >
              <Icon name="X" size={16} color="currentColor" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AlertBanner;